<!-- `task-head` / `btns` / `custom-button` are the class names every other dialog
     in this app uses, restated in this sheet so the header rule, the button row
     and the dark-theme overrides in styles.scss all land the same way here. -->
<div class="mld">

  <div class="task-head">
    <h4>{{ title }}</h4>
  </div>

  <p class="mld__sub" *ngIf="data.subtitle">{{ data.subtitle }}</p>

  <!-- The boundary is the wrapper's `rawGeoJson`, so it is also what `fitToData`
       frames when the dialog opens. Everything drawn on top belongs to
       MapDrawController, including the reset control in the corner. -->
  <div class="mld__map" #mapBox [class.is-max]="maximized">
    <app-leaflet-map-wrapper
      [rawGeoJson]="wrapperGeoJson"
      [interactive]="true"
      [showZoomControl]="true"
      [showAttribution]="true"
      [defaultBaseLayer]="'Openstreetmap'"
      [pointRenderMode]="'marker'"
      [pathStyle]="boundaryStyle"
      (mapReady)="onMapReady($event)">
    </app-leaflet-map-wrapper>

    <!-- Same gesture, artwork and corner as the collections map's own. -->
    <div class="mld__max" (click)="toggleMaximize()"
         [title]="maximized ? 'Exit full screen' : 'Full screen'">
      <img [src]="maximized ? 'assets/images/download-3.svg' : 'assets/images/download.svg'" alt="" />
    </div>

    <!-- Shown while a tool is armed, saying what that tool wants; and while
         nothing is armed and nothing is marked, when the thing to say is
         "pick a tool". Silent once a shape exists and no tool is up — the
         read-back below is doing the talking by then. -->
    <span class="mld__pill" *ngIf="!fixedToBoundary && (tool || state === 'idle')">{{ hint }}</span>
  </div>

  <div class="mld__read" [ngClass]="'is-' + state">
    <span *ngIf="state === 'bad'">{{ error }}</span>
    <span *ngIf="state === 'ok'">
      {{ summary?.title }} {{ shape?.kind === 'area' ? '-' : '—' }} <b>{{ summary?.detail }}</b>
      <small *ngIf="shape?.kind === 'point'">
        Including a buffer zone with a {{ toleranceM }}-meter radius
      </small>
    </span>
    
  </div>

  <!-- Kept because coordinates do arrive in emails and reports, and retyping
       them is not worse than drawing them. Collapsed, because the map is the
       path being offered. -->
  <div class="mld__typed" *ngIf="!fixedToBoundary">
    <button type="button" class="mld__lnk" (click)="typedOpen = !typedOpen"
            [attr.aria-expanded]="typedOpen">
      {{ typedOpen ? 'Hide coordinates' : 'Or type the coordinates' }}
    </button>
    <div class="mld__typed-body" *ngIf="typedOpen">
      <mat-form-field appearance="outline" class="mld__field">
        <input matInput
               [value]="typed"
               placeholder="55.342, 25.161"
               (input)="onTypedInput($any($event.target).value)" />
      </mat-form-field>
      <div class="mld__hint">
        Coordinate pair is entered as Lng, Lat. Three or more pairs separated by semicolons create an area.
      </div>
    </div>
  </div>

  <div class="btns">
    <button type="button" class="custom-button" (click)="cancel()">Close</button>
    <button mat-flat-button type="button" [disabled]="!canSubmit" (click)="submit()"
            [matTooltip]="blockedReason || ''"
            [matTooltipDisabled]="!blockedReason">
      {{ confirmLabel }}
    </button>
  </div>

</div>
